/*
 * Copyright (c) 2020. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <https://veneliniliev.com>
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared';
import { NotificationsRoutingModule } from '@app/notifications/notifications-routing.module';
import { NotificationsListComponent } from './notifications/notifications-list/notifications-list.component';

@NgModule({
  declarations: [NotificationsListComponent],
  imports: [CommonModule, SharedModule, NotificationsRoutingModule],
})
export class NotificationsModule {}
